export const sentimentVoice = {
	REQUEST: 'SENTIMENT_VOICE_REQUEST',
	RECEIVE: 'SENTIMENT_VOICE_RECEIVE',
};



// WEBPACK FOOTER //
// ./src/constants/widgetSentiment.constants.js